import React from 'react'
import SchemaForm from 'components/forms/SchemaForm'
import { connect } from 'react-redux'
import { fetchEntities } from 'actions/entities'

import invoiceSchema from 'forms/invoiceSchema'
import { Icon } from "semantic-ui-react";
import { Button } from "semantic-ui-react";
import { actions } from "../../react-redux-form";

class InvoiceForm extends React.Component {
  componentDidMount() {
    this.props.fetchResources()
  }

  render () {

    let SubmitButton = (props) => {
      return([
        <Button animated='vertical' onClick={ (event, data) => {this.props.setToConcept(true) ;props.submit()}} >
          <Button.Content hidden>
            <Icon name='hand peace outline' />
          </Button.Content>
          <Button.Content visible>
            <Icon name='save' /> {'Opslaan als concept'}
          </Button.Content>
        </Button>,
        <Button animated='vertical' color='green' onClick={ (event, data) => {this.props.setToConcept(false) ;props.submit()}} >
          <Button.Content hidden>
            <Icon name='hand peace outline' />
          </Button.Content>
          <Button.Content visible>
            <Icon name='checkmark' /> {'Factuur uitgeven'}
          </Button.Content>
        </Button>])
    }

    return (
      <SchemaForm entityName='invoice' {...this.props} SubmitButton = {SubmitButton} afterSaveNavigation = "overview"/>
      )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    uiSchema: invoiceSchema(state, ownProps)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchResources: () => {
      dispatch(fetchEntities('organisations'))
      dispatch(fetchEntities('invoiceConfigurations'))
    },
    setToConcept: (isConcept) => {
      dispatch(actions.change(`entities.invoice.byId.${ownProps.entityId}.concept`, isConcept))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(InvoiceForm);
